<template>
  <hy-select v-model="attribute.selected.value" 
              :items="filterActiveLookups(attribute.LOOKUPS.value).filter(filter)" 
              :labelFunction="label"
              :nullable="attribute.metadata.isNullable() || attribute.value === null" 
              :placeholder="placeholder"
              />
</template>

<script>
import Reference from "../../xmlrdb-data/Reference"
import HySelect from "../../basic-components/HySelect.vue"

export default {
  components: {
    HySelect
  },
  props: {
    attribute: Reference,
    placeholder: { type: String, default: "Bitte auswählen" },
    filter: { type: Function, default: () => true },
  },
  setup(props){
    const css = props.attribute.metadata.inputFieldCSS();
    function label (obj){
      if(obj){
        return props.attribute.lookupElement.getLookupLabel(obj);
      }
      return "";
    }
    

    function filterActiveLookups(lookups){
      let activeAttributeNames = props.attribute.lookupElement.allAttributes.filter( a => a.tagValueByName("isLookupActiveIndicator") === "true").map( a => a.name());
      return lookups.filter( l => props.attribute.selected.value === l || !activeAttributeNames.some( attrname => l[attrname] == false));
    }

    return {
      label,css,
      filterActiveLookups,
    }
  }
}
</script>

<style>
  .reference-select{
    width:100%;
  }
</style>